import graphqlClient from "../../../api/axios_interceptor";
import { getTenantFinancialsQuery, getTenantPaymentQuery } from "../../../api/graphql/tenantApp/queries/financials"
import { updateActionErrors } from './updateErrors';
import { GET_TENANT_FINANCIALS, GET_TENANT_PAYMENT } from "../actions/actionTypes";
import { parseTransaction } from "../../middleware/transactions";

export const fetchTenantFinancialsMiddleware = async (action) => {
    let financials = {};
    let payload = action.payload;
    try{
        await graphqlClient({
            data: {
                query: getTenantFinancialsQuery(payload.tenantId, payload.startDate, payload.endDate)
            }
        }).then((queryResult) => {
            if(queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors);
            }else{
                financials = queryResult.data.data.tenantFinancials.map(parseTransaction);
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        financials,
                        accountBalance: (financials.length > 0 ? financials[0].endOfDayBalance : null)
                    }
                };
            }
        })

    }catch(error){
        console.error(error);
        action = updateActionErrors(action);
    }
    return action;
};

export const fetchTenantPaymentMiddleware = async (action) => {
    let payload = action.payload;
    try{
        await graphqlClient({
            data: {
                query: getTenantPaymentQuery(payload.paymentId)
            }
        }).then((queryResult) => {
            if(queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors);
            }else{
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        payment: queryResult.data.data.tenantPayment
                    }
                };
            }
        })

    }catch(error){
        console.error(error);
        action = updateActionErrors(action);
    }
    return action;
}

export const tenantFinancialsMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case GET_TENANT_FINANCIALS:
            action = await fetchTenantFinancialsMiddleware(action);
            break;
        case GET_TENANT_PAYMENT:
            action = await fetchTenantPaymentMiddleware(action);
            break;
    }
    return next(action);
}